// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"07292e46","239":"282e33af","453":"ad7309c3","732":"8d34dde7"}[chunkId] + ".chunk.js";
};